"use client";

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect } from "react";
import { loadGsapWithScrollTrigger, shouldReduceMotion } from "@/lib/gsap";
export function useWhyFlowlabAnimation(sectionRef) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== sectionRef) {
    t0 = () => {
      if (shouldReduceMotion()) {
        return;
      }
      let cleanup;
      let cancelled = false;
      const setupAnimation = async function setupAnimation() {
        const {
          gsap,
          ScrollTrigger
        } = await loadGsapWithScrollTrigger();
        if (cancelled || !sectionRef.current) {
          return;
        }
        const ctx = gsap.context(() => {
          const intro = gsap.utils.toArray(".why-flowlab-intro");
          const background = sectionRef.current?.querySelector(".why-flowlab-bg");
          gsap.set(intro, {
            opacity: 0,
            y: 28,
            filter: "blur(8px)"
          });
          gsap.to(intro, {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 1,
            ease: "power3.out",
            stagger: 0.1,
            scrollTrigger: {
              trigger: sectionRef.current,
              start: "top 80%",
              toggleActions: "play reverse restart reverse"
            }
          });
          if (background) {
            gsap.fromTo(background, {
              yPercent: -3,
              scale: 1.03
            }, {
              yPercent: 3,
              scale: 1,
              ease: "none",
              scrollTrigger: {
                trigger: sectionRef.current,
                start: "top bottom",
                end: "bottom top",
                scrub: true
              }
            });
          }
        }, sectionRef);
        ScrollTrigger.refresh();
        cleanup = () => ctx.revert();
      };
      setupAnimation();
      return () => {
        cancelled = true;
        cleanup?.();
      };
    };
    t1 = [sectionRef];
    $[0] = sectionRef;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}